import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { ADMIN_EMAIL } from '../config/emailConfig';

// ==================== E-POSTA SERVİSİ ====================
// Firebase Trigger Email Extension kullanılarak e-posta gönderimi

const mailCollection = collection(db, 'mail');

/**
 * E-posta gönderme helper fonksiyonu
 * Firebase Trigger Email Extension kullanır
 */
const sendEmail = async (to, subject, html, text = '') => {
  try {
    await addDoc(mailCollection, {
      to: to,
      message: {
        subject: subject,
        html: html,
        text: text || subject
      },
      createdAt: serverTimestamp()
    });

    console.log('✅ E-posta gönderim kuyruğuna eklendi:', to);
    return { success: true };
  } catch (error) {
    console.error('❌ E-posta gönderme hatası:', error);
    return { success: false, error: error.message };
  }
};

// ==================== E-POSTA ŞABLONLARI ====================

/**
 * Sipariş oluşturuldu - Müşteri
 */
export const sendOrderConfirmationEmail = async (orderData) => {
  const {
    customerEmail,
    customerName,
    orderNumber,
    total,
    items,
    shippingAddress,
    isCancellation = false, // ✅ İptal maili mi?
    cancellationReason,
    refundAmount,
    refundMethod
  } = orderData;

  const itemsHtml = items.map(item => `
    <tr>
      <td style="padding: 10px; border-bottom: 1px solid #eee;">
        <strong>${item.productName}</strong><br>
        <small>Adet: ${item.quantity}</small>
      </td>
      <td style="padding: 10px; border-bottom: 1px solid #eee; text-align: right;">
        ${(item.price * item.quantity).toFixed(2)} ₺
      </td>
    </tr>
  `).join('');

  // ✅ İPTAL MAİLİ İÇİN FARKLI ŞABLON
  if (isCancellation) {
    const html = `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8">
        <style>
          body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
          .container { max-width: 600px; margin: 0 auto; padding: 20px; }
          .header { background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%); color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
          .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
          .order-info { background: white; padding: 20px; border-radius: 8px; margin: 20px 0; }
          .total { font-size: 24px; font-weight: bold; color: #ef4444; text-align: right; margin-top: 20px; }
          .footer { text-align: center; margin-top: 30px; padding: 20px; color: #666; font-size: 14px; }
          table { width: 100%; border-collapse: collapse; }
          .refund-box { background: #fef2f2; border: 2px solid #ef4444; padding: 20px; border-radius: 8px; margin: 20px 0; }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <h1>❌ Siparişiniz İptal Edildi</h1>
            <p>Sipariş No: ${orderNumber}</p>
          </div>
          <div class="content">
            <p>Merhaba ${customerName || ''},</p>
            <p>Siparişiniz başarıyla iptal edilmiştir.</p>
            
            <div class="refund-box">
              <h3>💰 İade Bilgileri</h3>
              <p><strong>İade Tutarı:</strong> ${refundAmount?.toFixed(2) || total.toFixed(2)} ₺</p>
              <p><strong>İade Yöntemi:</strong> ${refundMethod === 'card' ? 'Kredi Kartı' : 'Nakit'}</p>
              ${refundMethod === 'card'
        ? '<p><strong>İade Süresi:</strong> 3-5 iş günü içinde hesabınıza yansıyacaktır.</p>'
        : '<p><strong>İade Süresi:</strong> Müşteri temsilcimiz en kısa sürede sizinle iletişime geçecektir.</p>'
      }
              <p><strong>İptal Nedeni:</strong> ${cancellationReason || 'Belirtilmemiş'}</p>
            </div>
            
            <div class="order-info">
              <h3>📦 İptal Edilen Ürünler</h3>
              <table>
                <thead>
                  <tr style="background: #f0f0f0;">
                    <th style="padding: 10px; text-align: left;">Ürün</th>
                    <th style="padding: 10px; text-align: right;">Tutar</th>
                  </tr>
                </thead>
                <tbody>
                  ${itemsHtml}
                </tbody>
              </table>
              <div class="total">Toplam: ${total.toFixed(2)} ₺</div>
            </div>
            
            <p style="margin-top: 30px;">Herhangi bir sorunuz varsa lütfen bizimle iletişime geçin.</p>
          </div>
          <div class="footer">
            <p>Bizi tercih ettiğiniz için teşekkür ederiz! ❤️</p>
            <p style="font-size: 12px; color: #999;">Bu bir otomatik e-postadır, lütfen yanıtlamayın.</p>
          </div>
        </div>
      </body>
      </html>
    `;

    return sendEmail(
      customerEmail,
      `Sipariş İptali - ${orderNumber}`,
      html
    );
  }

  // ✅ NORMAL SİPARİŞ ONAY MAİLİ (MEVCUT KOD - DEĞİŞİKLİK YOK)
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .order-info { background: white; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .total { font-size: 24px; font-weight: bold; color: #667eea; text-align: right; margin-top: 20px; }
        .footer { text-align: center; margin-top: 30px; padding: 20px; color: #666; font-size: 14px; }
        table { width: 100%; border-collapse: collapse; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>🎉 Siparişiniz Alındı!</h1>
          <p>Sipariş No: ${orderNumber}</p>
        </div>
        <div class="content">
          <p>Merhaba,</p>
          <p>Siparişiniz başarıyla oluşturuldu ve en kısa sürede işleme alınacaktır.</p>
          
          <div class="order-info">
            <h3>📦 Sipariş Detayları</h3>
            <table>
              <thead>
                <tr style="background: #f0f0f0;">
                  <th style="padding: 10px; text-align: left;">Ürün</th>
                  <th style="padding: 10px; text-align: right;">Tutar</th>
                </tr>
              </thead>
              <tbody>
                ${itemsHtml}
              </tbody>
            </table>
            <div class="total">Toplam: ${total.toFixed(2)} ₺</div>
          </div>
          
          <div class="order-info">
            <h3>🚚 Teslimat Adresi</h3>
            <p>
              ${shippingAddress.firstName} ${shippingAddress.lastName}<br>
              ${shippingAddress.address}<br>
              ${shippingAddress.city} / ${shippingAddress.district}<br>
              Tel: ${shippingAddress.phone}
            </p>
          </div>
          
          <p style="margin-top: 30px;">Siparişinizin durumunu hesabınızdan takip edebilirsiniz.</p>
        </div>
        <div class="footer">
          <p>Bizi tercih ettiğiniz için teşekkür ederiz! ❤️</p>
          <p style="font-size: 12px; color: #999;">Bu bir otomatik e-postadır, lütfen yanıtlamayın.</p>
        </div>
      </div>
    </body>
    </html>
  `;

  return sendEmail(customerEmail, `Siparişiniz Alındı - ${orderNumber}`, html);
};

/**
 * Sipariş oluşturuldu - Satıcı (Admin)
 */
export const sendNewOrderNotificationToAdmin = async (orderData, adminEmail = ADMIN_EMAIL) => {
  const { orderNumber, total, items, customerName, shippingAddress } = orderData;

  const itemsHtml = items.map(item => `
    <tr>
      <td style="padding: 8px; border-bottom: 1px solid #eee;">${item.productName}</td>
      <td style="padding: 8px; border-bottom: 1px solid #eee; text-align: center;">${item.quantity}</td>
      <td style="padding: 8px; border-bottom: 1px solid #eee; text-align: right;">${(item.price * item.quantity).toFixed(2)} ₺</td>
    </tr>
  `).join('');

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: #28a745; color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .alert-box { background: #fff3cd; border-left: 4px solid #ffc107; padding: 15px; margin: 20px 0; border-radius: 4px; }
        .order-info { background: white; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .total { font-size: 24px; font-weight: bold; color: #28a745; text-align: right; margin-top: 20px; }
        table { width: 100%; border-collapse: collapse; }
        .btn { display: inline-block; padding: 12px 30px; background: #28a745; color: white; text-decoration: none; border-radius: 5px; margin-top: 20px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>🔔 Yeni Sipariş Alındı!</h1>
          <p style="font-size: 20px; margin: 10px 0;">Sipariş No: ${orderNumber}</p>
        </div>
        <div class="content">
          <div class="alert-box">
            <strong>⚠️ Acil:</strong> Yeni bir sipariş oluşturuldu ve işleme alınması bekleniyor!
          </div>
          
          <div class="order-info">
            <h3>👤 Müşteri Bilgileri</h3>
            <p>
              <strong>Ad Soyad:</strong> ${customerName}<br>
              <strong>Telefon:</strong> ${shippingAddress.phone}<br>
              <strong>Adres:</strong> ${shippingAddress.address}, ${shippingAddress.district}/${shippingAddress.city}
            </p>
          </div>
          
          <div class="order-info">
            <h3>📦 Sipariş İçeriği</h3>
            <table>
              <thead>
                <tr style="background: #f0f0f0;">
                  <th style="padding: 10px; text-align: left;">Ürün</th>
                  <th style="padding: 10px; text-align: center;">Adet</th>
                  <th style="padding: 10px; text-align: right;">Tutar</th>
                </tr>
              </thead>
              <tbody>
                ${itemsHtml}
              </tbody>
            </table>
            <div class="total">Toplam: ${total.toFixed(2)} ₺</div>
          </div>
          
          <div style="text-align: center;">
            <a href="https://yourdomain.com/admin" class="btn">Siparişi Görüntüle</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;

  return sendEmail(adminEmail, `🔔 YENİ SİPARİŞ: ${orderNumber} - ${total.toFixed(2)} ₺`, html);
};

/**
 * Kargo bildirimi - Müşteri
 * ✅ YENİ FONKSİYON
 */
export const sendShippingNotificationEmail = async (shippingData) => {
  const {
    customerEmail,
    customerName,
    orderNumber,
    trackingNumber,
    carrier = 'Sürat Kargo',
    estimatedDelivery
  } = shippingData;

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { 
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); 
          color: white; 
          padding: 40px; 
          text-align: center; 
          border-radius: 10px 10px 0 0; 
        }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .tracking-box { 
          background: linear-gradient(135deg, #10b981 0%, #059669 100%); 
          color: white; 
          padding: 30px; 
          border-radius: 12px; 
          text-align: center; 
          margin: 20px 0;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }
        .tracking-number { 
          font-size: 28px; 
          font-weight: bold; 
          letter-spacing: 2px; 
          margin: 15px 0;
          font-family: monospace;
          background: rgba(255,255,255,0.2);
          padding: 15px;
          border-radius: 8px;
        }
        .info-box { 
          background: white; 
          padding: 20px; 
          border-radius: 8px; 
          margin: 20px 0;
          border-left: 4px solid #3b82f6;
        }
        .timeline { 
          background: white; 
          padding: 20px; 
          border-radius: 8px; 
          margin: 20px 0;
        }
        .timeline-item {
          display: flex;
          align-items: flex-start;
          margin: 15px 0;
          padding-bottom: 15px;
          border-bottom: 1px dashed #e5e7eb;
        }
        .timeline-item:last-child {
          border-bottom: none;
        }
        .timeline-icon {
          width: 40px;
          height: 40px;
          background: #3b82f6;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 15px;
          flex-shrink: 0;
          font-size: 18px;
        }
        .timeline-icon.active {
          background: #10b981;
        }
        .timeline-content h4 {
          margin: 0 0 5px 0;
          color: #1f2937;
        }
        .timeline-content p {
          margin: 0;
          color: #6b7280;
          font-size: 14px;
        }
        .btn { 
          display: inline-block; 
          padding: 14px 32px; 
          background: #3b82f6; 
          color: white; 
          text-decoration: none; 
          border-radius: 8px; 
          margin: 20px 0;
          font-weight: 600;
          box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
        }
        .btn:hover {
          background: #2563eb;
        }
        .footer { 
          text-align: center; 
          margin-top: 30px; 
          padding: 20px; 
          color: #666; 
          font-size: 14px; 
        }
        .delivery-info {
          background: #f0f9ff;
          border: 2px solid #bfdbfe;
          padding: 20px;
          border-radius: 8px;
          margin: 20px 0;
        }
        .delivery-info h3 {
          margin-top: 0;
          color: #1e40af;
          display: flex;
          align-items: center;
          gap: 8px;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <div style="font-size: 48px; margin-bottom: 10px;">📦</div>
          <h1 style="margin: 0 0 10px 0;">Siparişiniz Kargoya Verildi!</h1>
          <p style="margin: 0; opacity: 0.9;">Sipariş No: ${orderNumber}</p>
        </div>
        
        <div class="content">
          <p>Merhaba ${customerName || ''},</p>
          <p>Harika haberlerimiz var! 🎉 Siparişiniz <strong>${carrier}</strong> ile kargoya verildi ve yakında elinizde olacak.</p>
          
          <div class="tracking-box">
            <h3 style="margin: 0 0 10px 0; font-size: 16px; opacity: 0.9;">Takip Numaranız</h3>
            <div class="tracking-number">${trackingNumber}</div>
            <p style="margin: 10px 0 0 0; opacity: 0.9; font-size: 14px;">Bu numarayı kullanarak kargonuzu takip edebilirsiniz</p>
          </div>
          
          <div class="delivery-info">
            <h3>
              <span>🚚</span>
              Teslimat Bilgileri
            </h3>
            <p style="margin: 10px 0;">
              <strong>Kargo Firması:</strong> ${carrier}<br>
              ${estimatedDelivery ? `<strong>Tahmini Teslim:</strong> ${new Date(estimatedDelivery).toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })}<br>` : ''}
              <strong>Kargonuz genellikle 2-3 iş günü içinde teslim edilir</strong>
            </p>
          </div>
          
          <div class="timeline">
            <h3 style="margin-top: 0;">📍 Kargo Süreci</h3>
            
            <div class="timeline-item">
              <div class="timeline-icon active">✓</div>
              <div class="timeline-content">
                <h4>Sipariş Hazırlandı</h4>
                <p>Ürünleriniz paketlendi ve kargoya teslim edildi</p>
              </div>
            </div>
            
            <div class="timeline-item">
              <div class="timeline-icon">📦</div>
              <div class="timeline-content">
                <h4>Kargo Yolda</h4>
                <p>Kargonuz size ulaşmak için yola çıktı</p>
              </div>
            </div>
            
            <div class="timeline-item">
              <div class="timeline-icon">🏪</div>
              <div class="timeline-content">
                <h4>Dağıtım Merkezinde</h4>
                <p>Kargonuz size en yakın dağıtım merkezine ulaştı</p>
              </div>
            </div>
            
            <div class="timeline-item">
              <div class="timeline-icon">🎉</div>
              <div class="timeline-content">
                <h4>Teslim Edildi</h4>
                <p>Kargonuz adresinize teslim edilecek</p>
              </div>
            </div>
          </div>
          
          <div class="info-box">
            <h3 style="margin-top: 0;">💡 Önemli Bilgiler</h3>
            <ul style="margin: 10px 0; padding-left: 20px;">
              <li>Kargonuz adresinize teslim edilirken evde olmanız önerilir</li>
              <li>Teslimat sırasında fotoğraflı kimliğiniz istenebilir</li>
              <li>Paketi teslim alırken kontrol etmeyi unutmayın</li>
              <li>7 gün içinde iade hakkınızı kullanabilirsiniz</li>
            </ul>
          </div>
          
          <div style="text-align: center; margin: 30px 0;">
            <a href="https://gonderitakip.suratkargo.com.tr/Home/Track?code=${trackingNumber}" 
               class="btn" 
               style="color: white;">
              🔍 Kargonu Takip Et
            </a>
          </div>
          
          <div style="background: #f0fdf4; border: 2px solid #86efac; padding: 20px; border-radius: 8px; margin: 20px 0;">
            <h4 style="margin: 0 0 10px 0; color: #15803d;">📞 Yardıma mı ihtiyacınız var?</h4>
            <p style="margin: 0; color: #166534;">
              Herhangi bir sorunuz varsa müşteri hizmetlerimizle iletişime geçebilirsiniz.<br>
              <strong>Email:</strong> destek@orneksite.com<br>
              <strong>Telefon:</strong> 0850 123 45 67
            </p>
          </div>
        </div>
        
        <div class="footer">
          <p>Bizi tercih ettiğiniz için teşekkür ederiz! ❤️</p>
          <p style="font-size: 12px; color: #999; margin-top: 10px;">
            Bu bir otomatik e-postadır, lütfen yanıtlamayın.
          </p>
        </div>
      </div>
    </body>
    </html>
  `;

  const textContent = `
Siparişiniz Kargoya Verildi!

Sipariş No: ${orderNumber}
Takip No: ${trackingNumber}
Kargo: ${carrier}

Kargonuzu takip etmek için: https://gonderitakip.suratkargo.com.tr/Home/Track?code=${trackingNumber}

Bizi tercih ettiğiniz için teşekkür ederiz!
  `;

  return sendEmail(
    customerEmail,
    `📦 Kargoya Verildi - Sipariş ${orderNumber}`,
    html,
    textContent
  );
};

/**
 * Düşük stok uyarısı - Satıcı (Admin)
 */
export const sendLowStockAlert = async (productData, adminEmail = ADMIN_EMAIL) => {
  const { productName, sku, currentStock, minStock, category } = productData;

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: #ff9800; color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .warning-box { background: #fff3cd; border-left: 4px solid #ff9800; padding: 20px; margin: 20px 0; border-radius: 4px; }
        .stock-info { background: white; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .stock-level { font-size: 48px; font-weight: bold; color: #ff9800; text-align: center; margin: 20px 0; }
        .btn { display: inline-block; padding: 12px 30px; background: #ff9800; color: white; text-decoration: none; border-radius: 5px; margin-top: 20px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>⚠️ DÜŞÜK STOK UYARISI</h1>
        </div>
        <div class="content">
          <div class="warning-box">
            <h2 style="margin-top: 0;">Stok azaldı!</h2>
            <p>Aşağıdaki ürünün stoğu kritik seviyeye düştü ve tedarik gerekiyor.</p>
          </div>
          
          <div class="stock-info">
            <h3>📦 Ürün Bilgileri</h3>
            <p>
              <strong>Ürün Adı:</strong> ${productName}<br>
              <strong>SKU:</strong> ${sku}<br>
              <strong>Kategori:</strong> ${category}<br>
            </p>
            
            <div class="stock-level">${currentStock} / ${minStock}</div>
            <p style="text-align: center; color: #666;">Mevcut Stok / Minimum Stok</p>
            
            <div style="background: #f8d7da; padding: 15px; border-radius: 5px; text-align: center; margin-top: 20px;">
              <strong style="color: #721c24;">⚠️ Stok %${Math.round((currentStock / minStock) * 100)} seviyesinde</strong>
            </div>
          </div>
          
          <div style="text-align: center;">
            <a href="http://localhost:3000/admin" class="btn">Ürünü Düzenle</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;

  return sendEmail(adminEmail, `⚠️ DÜŞÜK STOK: ${productName} (${currentStock} adet kaldı)`, html);
};

/**
 * Stok tükendi - Satıcı (Admin)
 */
export const sendOutOfStockAlert = async (productData, adminEmail = ADMIN_EMAIL) => {
  const { productName, sku, category, lastSaleDate } = productData;

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: #dc3545; color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .danger-box { background: #f8d7da; border-left: 4px solid #dc3545; padding: 20px; margin: 20px 0; border-radius: 4px; }
        .stock-info { background: white; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .btn { display: inline-block; padding: 12px 30px; background: #dc3545; color: white; text-decoration: none; border-radius: 5px; margin-top: 20px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>🚨 STOK TÜKENDİ!</h1>
        </div>
        <div class="content">
          <div class="danger-box">
            <h2 style="margin-top: 0; color: #721c24;">Acil Eylem Gerekli!</h2>
            <p>Aşağıdaki ürünün stoğu tamamen tükendi. Satışlar kaybediliyor!</p>
          </div>
          
          <div class="stock-info">
            <h3>📦 Ürün Bilgileri</h3>
            <p>
              <strong>Ürün Adı:</strong> ${productName}<br>
              <strong>SKU:</strong> ${sku}<br>
              <strong>Kategori:</strong> ${category}<br>
              ${lastSaleDate ? `<strong>Son Satış:</strong> ${new Date(lastSaleDate).toLocaleDateString('tr-TR')}<br>` : ''}
            </p>
            
            <div style="background: #dc3545; color: white; padding: 30px; border-radius: 5px; text-align: center; margin-top: 20px;">
              <h2 style="margin: 0; font-size: 36px;">0 ADET</h2>
              <p style="margin: 10px 0 0 0;">Stok Tamamen Tükendi</p>
            </div>
          </div>
          
          <div style="background: #fff3cd; padding: 15px; border-radius: 5px; margin: 20px 0;">
            <strong>💡 Öneriler:</strong>
            <ul>
              <li>Tedarikçi ile hemen iletişime geçin</li>
              <li>Ürünü geçici olarak pasif yapın</li>
              <li>Müşteri bildirimlerini aktifleştirin</li>
            </ul>
          </div>
          
          <div style="text-align: center;">
            <a href="https://yourdomain.com/admin/products" class="btn">Acil İşlem Yap</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;

  return sendEmail(adminEmail, `🚨 STOK TÜKENDİ: ${productName}`, html);
};

/**
 * İade talebi oluşturuldu - Satıcı (Admin)
 */
export const sendReturnRequestToAdmin = async (returnData, adminEmail = ADMIN_EMAIL) => {
  const { orderNumber, customerName, reason, reasonDetail, total, items } = returnData;

  const itemsHtml = items.map(item => `
    <li style="padding: 5px 0;">${item.productName} (x${item.quantity})</li>
  `).join('');

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: #17a2b8; color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .alert-box { background: #d1ecf1; border-left: 4px solid #17a2b8; padding: 15px; margin: 20px 0; border-radius: 4px; }
        .return-info { background: white; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .btn { display: inline-block; padding: 12px 30px; background: #17a2b8; color: white; text-decoration: none; border-radius: 5px; margin: 10px 5px; }
        .btn-approve { background: #28a745; }
        .btn-reject { background: #dc3545; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>🔄 Yeni İade Talebi</h1>
          <p style="font-size: 20px; margin: 10px 0;">Sipariş No: ${orderNumber}</p>
        </div>
        <div class="content">
          <div class="alert-box">
            <strong>📋 İşlem Gerekiyor:</strong> Müşteri iade talebi oluşturdu ve onayınızı bekliyor.
          </div>
          
          <div class="return-info">
            <h3>👤 Müşteri Bilgileri</h3>
            <p><strong>${customerName}</strong></p>
            
            <h3 style="margin-top: 20px;">📦 İade Edilecek Ürünler</h3>
            <ul style="padding-left: 20px;">
              ${itemsHtml}
            </ul>
            
            <h3>💰 İade Tutarı</h3>
            <p style="font-size: 24px; font-weight: bold; color: #17a2b8;">${total.toFixed(2)} ₺</p>
            
            <h3>📝 İade Nedeni</h3>
            <div style="background: #f8f9fa; padding: 15px; border-radius: 5px;">
              <strong>${reason}</strong>
              ${reasonDetail ? `<p style="margin: 10px 0 0 0;">${reasonDetail}</p>` : ''}
            </div>
          </div>
          
          <div style="text-align: center;">
            <a href="https://yourdomain.com/admin/returns" class="btn btn-approve">✅ Onayla</a>
            <a href="https://yourdomain.com/admin/returns" class="btn btn-reject">❌ Reddet</a>
          </div>
          
          <p style="text-align: center; color: #666; margin-top: 20px; font-size: 14px;">
            ⏰ İade talepleri 24 saat içinde değerlendirilmelidir.
          </p>
        </div>
      </div>
    </body>
    </html>
  `;

  return sendEmail(adminEmail, `🔄 YENİ İADE TALEBİ: ${orderNumber} - ${customerName}`, html);
};

/**
 * Yeni değerlendirme/yorum - Satıcı (Admin)
 */
export const sendNewReviewToAdmin = async (reviewData, adminEmail = ADMIN_EMAIL) => {
  const { productName, userName, rating, comment, isVerifiedPurchase } = reviewData;

  const starsHtml = '⭐'.repeat(rating) + '☆'.repeat(5 - rating);

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: #ffc107; color: #333; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .review-box { background: white; padding: 20px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #ffc107; }
        .rating { font-size: 32px; text-align: center; margin: 20px 0; }
        .badge { display: inline-block; padding: 5px 10px; background: #28a745; color: white; border-radius: 3px; font-size: 12px; }
        .btn { display: inline-block; padding: 12px 30px; background: #ffc107; color: #333; text-decoration: none; border-radius: 5px; margin-top: 20px; font-weight: bold; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>⭐ Yeni Değerlendirme</h1>
          <p style="font-size: 18px; margin: 10px 0;">${productName}</p>
        </div>
        <div class="content">
          <div class="review-box">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
              <strong style="font-size: 18px;">👤 ${userName}</strong>
              ${isVerifiedPurchase ? '<span class="badge">✓ Onaylı Alıcı</span>' : ''}
            </div>
            
            <div class="rating">${starsHtml}</div>
            <p style="text-align: center; color: #666; margin: 0;">${rating} / 5 yıldız</p>
            
            <div style="background: #f8f9fa; padding: 20px; border-radius: 5px; margin-top: 20px;">
              <h3 style="margin-top: 0;">💬 Yorum:</h3>
              <p style="font-style: italic;">"${comment}"</p>
            </div>
          </div>
          
          <div style="background: #fff3cd; padding: 15px; border-radius: 5px; margin: 20px 0;">
            <strong>💡 İpucu:</strong> Değerlendirmelere hızlı yanıt vermek müşteri memnuniyetini artırır!
          </div>
          
          <div style="text-align: center;">
            <a href="https://yourdomain.com/admin/reviews" class="btn">Değerlendirmeyi Görüntüle</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;

  return sendEmail(adminEmail, `⭐ YENİ DEĞERLENDİRME: ${productName} - ${rating} yıldız`, html);
};

/**
 * Sipariş iptal edildi - Satıcı (Admin)
 */
export const sendOrderCancellationToAdmin = async (cancellationData, adminEmail = ADMIN_EMAIL) => {
  const { orderNumber, customerName, reason, reasonDetail, total, items } = cancellationData;

  const itemsHtml = items.map(item => `
    <li style="padding: 5px 0;">${item.productName} (x${item.quantity}) - ${(item.price * item.quantity).toFixed(2)} ₺</li>
  `).join('');

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: #6c757d; color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .cancel-info { background: white; padding: 20px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #dc3545; }
        .btn { display: inline-block; padding: 12px 30px; background: #6c757d; color: white; text-decoration: none; border-radius: 5px; margin-top: 20px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>❌ Sipariş İptal Edildi</h1>
          <p style="font-size: 20px; margin: 10px 0;">Sipariş No: ${orderNumber}</p>
        </div>
        <div class="content">
          <div class="cancel-info">
            <h3>👤 Müşteri: ${customerName}</h3>
            
            <h3 style="margin-top: 20px;">📦 İptal Edilen Ürünler</h3>
            <ul style="padding-left: 20px;">
              ${itemsHtml}
            </ul>
            
            <h3>💸 İptal Tutarı</h3>
            <p style="font-size: 24px; font-weight: bold; color: #dc3545;">${total.toFixed(2)} ₺</p>
            
            <h3>📝 İptal Nedeni</h3>
            <div style="background: #f8f9fa; padding: 15px; border-radius: 5px;">
              <strong>${reason}</strong>
              ${reasonDetail ? `<p style="margin: 10px 0 0 0;">${reasonDetail}</p>` : ''}
            </div>
          </div>
          
          <div style="background: #d1ecf1; padding: 15px; border-radius: 5px; margin: 20px 0; border-left: 4px solid #17a2b8;">
            <strong>ℹ️ Bilgi:</strong> Stoklar otomatik olarak güncellendi ve iade işlemi başlatıldı.
          </div>
          
          <div style="text-align: center;">
            <a href="https://yourdomain.com/admin/orders" class="btn">Siparişi Görüntüle</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;

  return sendEmail(adminEmail, `❌ SİPARİŞ İPTAL: ${orderNumber} - ${total.toFixed(2)} ₺`, html);
};

/**
 * Kampanya süresi dolmak üzere - Satıcı (Admin)
 */
export const sendCampaignEndingSoonAlert = async (campaignData, adminEmail = ADMIN_EMAIL) => {
  const { title, endDate, discountValue, affectedProductsCount } = campaignData;

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: #673ab7; color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .campaign-info { background: white; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .countdown { background: #ff9800; color: white; padding: 20px; border-radius: 5px; text-align: center; font-size: 24px; font-weight: bold; margin: 20px 0; }
        .btn { display: inline-block; padding: 12px 30px; background: #673ab7; color: white; text-decoration: none; border-radius: 5px; margin-top: 20px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>⏰ Kampanya Süresi Doluyor!</h1>
        </div>
        <div class="content">
          <div class="campaign-info">
            <h2 style="margin-top: 0; color: #673ab7;">${title}</h2>
            
            <div class="countdown">
              ⏰ 24 SAAT KALDI
            </div>
            
            <p style="text-align: center;">
              <strong>Bitiş Tarihi:</strong> ${new Date(endDate).toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })}
            </p>
            
            <div style="background: #f8f9fa; padding: 20px; border-radius: 5px; margin: 20px 0;">
              <h3 style="margin-top: 0;">📊 Kampanya Detayları</h3>
              <p>
                <strong>İndirim Oranı:</strong> %${discountValue}<br>
                <strong>Etkilenen Ürün Sayısı:</strong> ${affectedProductsCount} adet
              </p>
            </div>
          </div>
          
          <div style="background: #fff3cd; padding: 15px; border-radius: 5px; margin: 20px 0;">
            <strong>💡 Yapılabilecekler:</strong>
            <ul>
              <li>Kampanyayı uzatmayı düşünün</li>
              <li>Yeni bir kampanya hazırlayın</li>
              <li>Ürün fiyatlarını kontrol edin</li>
            </ul>
          </div>
          
          <div style="text-align: center;">
            <a href="https://yourdomain.com/admin/campaigns" class="btn">Kampanyayı Yönet</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;

  return sendEmail(adminEmail, `⏰ KAMPANYA SONA ERİYOR: ${title} (24 saat kaldı)`, html);
};

/**
 * Günlük sipariş özeti - Satıcı (Admin)
 */
export const sendDailyOrderSummary = async (summaryData, adminEmail = ADMIN_EMAIL) => {
  const { date, totalOrders, totalRevenue, pendingOrders, completedOrders, cancelledOrders, topProducts } = summaryData;

  const topProductsHtml = topProducts.map((product, index) => `
    <tr>
      <td style="padding: 10px; border-bottom: 1px solid #eee;">${index + 1}</td>
      <td style="padding: 10px; border-bottom: 1px solid #eee;">${product.name}</td>
      <td style="padding: 10px; border-bottom: 1px solid #eee; text-align: center;">${product.sales}</td>
      <td style="padding: 10px; border-bottom: 1px solid #eee; text-align: right;">${product.revenue.toFixed(2)} ₺</td>
    </tr>
  `).join('');

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 700px; margin: 0 auto; padding: 20px; }
        .header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 40px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .stats-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; margin: 20px 0; }
        .stat-card { background: white; padding: 20px; border-radius: 8px; text-align: center; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
        .stat-number { font-size: 32px; font-weight: bold; color: #667eea; margin: 10px 0; }
        .stat-label { color: #666; font-size: 14px; }
        .revenue-box { background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); color: white; padding: 30px; border-radius: 8px; text-align: center; margin: 20px 0; }
        table { width: 100%; border-collapse: collapse; background: white; border-radius: 8px; overflow: hidden; }
        th { background: #667eea; color: white; padding: 12px; text-align: left; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>📊 Günlük Satış Raporu</h1>
          <p style="font-size: 18px; margin: 10px 0;">${new Date(date).toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })}</p>
        </div>
        <div class="content">
          <div class="revenue-box">
            <h2 style="margin: 0;">💰 Günlük Ciro</h2>
            <div style="font-size: 48px; font-weight: bold; margin: 20px 0;">${totalRevenue.toFixed(2)} ₺</div>
            <p style="margin: 0; opacity: 0.9;">Toplam ${totalOrders} sipariş</p>
          </div>
          
          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-label">⏳ Bekleyen</div>
              <div class="stat-number" style="color: #ff9800;">${pendingOrders}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">✅ Tamamlanan</div>
              <div class="stat-number" style="color: #28a745;">${completedOrders}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">❌ İptal</div>
              <div class="stat-number" style="color: #dc3545;">${cancelledOrders}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">📈 Toplam</div>
              <div class="stat-number">${totalOrders}</div>
            </div>
          </div>
          
          <div style="background: white; padding: 20px; border-radius: 8px; margin-top: 20px;">
            <h3>🏆 En Çok Satan Ürünler</h3>
            <table>
              <thead>
                <tr>
                  <th>Sıra</th>
                  <th>Ürün</th>
                  <th style="text-align: center;">Satış</th>
                  <th style="text-align: right;">Gelir</th>
                </tr>
              </thead>
              <tbody>
                ${topProductsHtml}
              </tbody>
            </table>
          </div>
          
          <p style="text-align: center; color: #666; margin-top: 30px;">
            Bu rapor her gün sabah 08:00'de otomatik olarak gönderilir.
          </p>
        </div>
      </div>
    </body>
    </html>
  `;

  return sendEmail(adminEmail, `📊 Günlük Rapor: ${totalOrders} sipariş - ${totalRevenue.toFixed(2)} ₺`, html);
};

// ✅ 🆕 Fatura mail fonksiyonu (emailService.js'e de eklenebilir)
export const sendInvoiceEmail = async (invoiceData) => {
  const { customerEmail, orderNumber, invoiceNumber, invoicePdfUrl } = invoiceData;

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { 
          background: linear-gradient(135deg, #10b981 0%, #059669 100%); 
          color: white; 
          padding: 30px; 
          text-align: center; 
          border-radius: 10px 10px 0 0; 
        }
        .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
        .invoice-box { 
          background: #fff; 
          padding: 24px; 
          border-radius: 12px; 
          border: 2px solid #10b981;
          margin: 20px 0;
          text-align: center;
        }
        .btn { 
          display: inline-block; 
          padding: 14px 32px; 
          background: #10b981; 
          color: white; 
          text-decoration: none; 
          border-radius: 8px; 
          font-weight: 600;
          margin-top: 20px;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>📄 E-Faturanız Hazır!</h1>
        </div>
        <div class="content">
          <p>Merhaba,</p>
          <p><strong>${orderNumber}</strong> numaralı siparişinize ait e-faturanız oluşturuldu.</p>
          
          <div class="invoice-box">
            <h3 style="margin: 0 0 10px 0; color: #10b981;">Fatura Bilgileri</h3>
            <p style="margin: 0;">
              <strong>Fatura No:</strong> ${invoiceNumber}<br>
              <strong>Sipariş No:</strong> ${orderNumber}
            </p>
            
            <a href="${invoicePdfUrl}" class="btn">
              📥 Faturayı İndir (PDF)
            </a>
          </div>
          
          <p style="font-size: 13px; color: #868e96; margin-top: 20px;">
            E-Faturanızı GİB (Gelir İdaresi Başkanlığı) portalından da görüntüleyebilirsiniz.
          </p>
        </div>
      </div>
    </body>
    </html>
  `;

  // Email servisini kullan (mevcut sendEmail fonksiyonunuz)
  return await sendEmail(
    customerEmail,
    `E-Faturanız Hazır - ${invoiceNumber}`,
    html
  );
};

// ✅ MÜŞTERİYE İADE ONAY MAİLİ
export const sendReturnApprovedToCustomer = async (returnData, customerEmail) => {
  try {
    console.log('📧 Müşteriye iade onay maili gönderiliyor...');
    
    const subject = `✅ İadeniz Onaylandı - ${returnData.orderNumber}`;
    
    const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    body { font-family: Arial, sans-serif; background: #f5f5f5; padding: 20px; }
    .container { max-width: 600px; margin: 0 auto; background: white; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
    .header { background: linear-gradient(135deg, #22c55e, #16a34a); padding: 30px; text-align: center; color: white; }
    .header h1 { margin: 0; font-size: 28px; }
    .content { padding: 30px; }
    .info-box { background: #f0fdf4; border-left: 4px solid #22c55e; padding: 15px; margin: 20px 0; border-radius: 8px; }
    .cargo-box { background: #fffbeb; border: 2px solid #f59e0b; padding: 20px; margin: 20px 0; border-radius: 12px; }
    .cargo-box h3 { color: #f59e0b; margin-top: 0; }
    .tracking-number { font-size: 24px; font-weight: bold; color: #16a34a; font-family: monospace; letter-spacing: 2px; text-align: center; margin: 15px 0; padding: 15px; background: white; border-radius: 8px; }
    .instructions { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
    .instructions ol { padding-left: 20px; }
    .instructions li { margin: 10px 0; line-height: 1.6; }
    .button { display: inline-block; background: #22c55e; color: white; padding: 12px 30px; text-decoration: none; border-radius: 8px; font-weight: bold; margin: 20px 0; }
    .footer { text-align: center; padding: 20px; color: #666; font-size: 12px; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>✅ İadeniz Onaylandı!</h1>
    </div>
    
    <div class="content">
      <p>Merhaba <strong>${returnData.customerName}</strong>,</p>
      
      <div class="info-box">
        <p><strong>${returnData.orderNumber}</strong> numaralı siparişinizin iade talebi onaylandı.</p>
      </div>
      
      <div class="cargo-box">
        <h3>🚚 İade Kargo Bilgileri</h3>
        <p><strong>Kargo Şirketi:</strong> Sürat Kargo</p>
        ${returnData.returnTrackingNumber ? `
          <p><strong>Takip Numaranız:</strong></p>
          <div class="tracking-number">${returnData.returnTrackingNumber}</div>
        ` : `
          <p>⚠️ Kargo etiketi manuel olarak oluşturulacak ve size iletilecektir.</p>
        `}
      </div>
      
      <div class="instructions">
        <h3>📋 İade Talimatları:</h3>
        <ol>
          <li>Ürünü orijinal ambalajında paketleyin</li>
          <li>${returnData.returnTrackingNumber ? 'İade etiketini pakete yapıştırın' : 'Size gönderilen iade etiketini bekleyin'}</li>
          <li>En yakın <strong>Sürat Kargo</strong> şubesine götürün</li>
          <li>Kargoya verdiğinizde sistemden "Kargoya Verdim" butonuna basın</li>
          <li>Ürün depoya ulaştıktan sonra ödemeniz iade edilecektir</li>
        </ol>
      </div>
      
      <div class="info-box">
        <h3>📍 İade Adresi:</h3>
        <p>
          <strong>${returnData.returnAddress.companyName}</strong><br>
          ${returnData.returnAddress.address}<br>
          ${returnData.returnAddress.district} / ${returnData.returnAddress.city}<br>
          ${returnData.returnAddress.zipCode}<br>
          Tel: ${returnData.returnAddress.phone}
        </p>
      </div>
      
      <p style="text-align: center;">
        <a href="https://www.tronapazarlama.com/orders/${returnData.orderNumber}" class="button">
          Sipariş Detayını Görüntüle
        </a>
      </p>
      
      <p>İyi günler dileriz,<br><strong>Trona Pazarlama</strong></p>
    </div>
    
    <div class="footer">
      <p>Bu mail otomatik olarak gönderilmiştir.</p>
      <p>&copy; 2025 Trona Pazarlama. Tüm hakları saklıdır.</p>
    </div>
  </div>
</body>
</html>
    `;
    
    // Firebase Functions ile mail gönder (veya başka mail servisi)
    // await sendMail(customerEmail, subject, htmlContent);
    
    console.log('✅ İade onay maili hazır');
    return { success: true };
  } catch (error) {
    console.error('❌ Mail gönderme hatası:', error);
    return { success: false, error: error.message };
  }
};

export default {
  sendOrderConfirmationEmail,
  sendNewOrderNotificationToAdmin,
  sendLowStockAlert,
  sendOutOfStockAlert,
  sendReturnRequestToAdmin,
  sendNewReviewToAdmin,
  sendOrderCancellationToAdmin,
  sendCampaignEndingSoonAlert,
  sendDailyOrderSummary,
  sendShippingNotificationEmail,
  sendInvoiceEmail,
  sendReturnApprovedToCustomer
};